// Commodity vocabulary, plus a Font Awesome fallback for the legend.
//
// The sidebar legend now renders the REAL symbol via
// dmirsSymbols.minedexSymbolDataUrl, so the map and the key cannot drift. These
// iconClassName/color fields remain only for the legacy Leaflet overlay in
// Map.js, which builds its markers from them.
//
// The commodityId strings are also the styling key: they must stay exactly
// equal to the 11 uniqueValue classes in the DMIRS SLIP renderer (field1 =
// "commodity"). Verified 2026-09-01 - all 11 match the database character for
// character.
export const minedexCommodoties = [
  { commodityId: "ALUMINA", iconClassName: "fa fa-solid fa-square", color: "#BF6347" },
  { commodityId: "IRON", iconClassName: "fa fa-solid fa-square", color: "#0000FF" },
  { commodityId: "PRECIOUS METAL", iconClassName: "fa fa-solid fa-square", color: "#FFFF00" },
  { commodityId: "SPECIALITY METAL", iconClassName: "fa fa-solid fa-square", color: "#00FF00" },
  { commodityId: "STEEL ALLOY METAL", iconClassName: "fa fa-solid fa-square", color: "#FEAC00" },
  { commodityId: "BASE METAL", iconClassName: "fa fa-solid fa-play fa-rotate-270", color: "#FF0000" },
  { commodityId: "CONSTRUCTION MATERIAL", iconClassName: "fa fa-solid fa-play fa-rotate-270", color: "#00DAFE" },
  { commodityId: "ENERGY", iconClassName: "fa fa-solid fa-play fa-rotate-270", color: "#000000" },
  { commodityId: "INDUSTRIAL MINERAL", iconClassName: "fa fa-solid fa-circle", color: "#008100" },
  // DMIRS draws this as a BLACK headframe (mast + bar + X brace), not a star -
  // verified against the picture marker in the SLIP renderer. The map now
  // renders the legend from dmirsSymbols.createMinedexSymbol directly, so these
  // two fields are only a fallback; they are corrected so the fallback is not
  // actively wrong.
  { commodityId: "PRECIOUS MINERAL", iconClassName: "fa fa-solid fa-tower-observation", color: "#000000" },
  { commodityId: "OTHER (MINEDEX NON-MINERALS)", iconClassName: "fa fa-solid fa-xmark", color: "#FF00FF" }
];


export const minedexTargetComodotiy = 
["ANTIMONY" 
,"IRON ORE"
,"ALUNITE"
,"COAL"
,"FLUORITE"
,"DIAMOND"
,"TIN - TANTALUM - LITHIUM"
,"SILVER"
,"TALC"
,"BISMUTH"
,"TUNGSTEN - MOLYBDENUM"
,"OTHER"
,"INDUSTRIAL PEGMATITE MINERALS"
,"ANDALUSITE - KYANITE - SILLIMANITE - CORUNDUM"
,"GRAPHITE"
,"DOLOMITE"
,"CLAYS"
,"GEM & SEMI-PRECIOUS STONES"
,"URANIUM"
,"NICKEL"
,"ARSENIC"
,"PEAT"
,"GYPSUM"
,"PIGMENTS"
,"BARITE"
,"PHOSPHATE"
,"UNASSIGNED"
,"COPPER - LEAD - ZINC"
,"ASBESTOS"
,"GREENSAND - GLAUCONITE"
,"POTASH"
,"HEAVY MINERAL SANDS"
,"LIMESTONE - LIMESAND"
,"MANGANESE ORE"
,"MAGNESITE"
,"SALT"
,"PYRITE - SULFUR"
,"GOLD"
,"DIMENSION STONE"
,"CHROMITE - PLATINOIDS"
,"CONSTRUCTION MATERIALS"
,"PETROLEUM"
,"VANADIUM - TITANIUM"
,"RARE EARTHS"
,"DIATOMITE - SPONGOLITE"
,"VERMICULITE"
,"BAUXITE - ALUMINA"
,"CHEMICALS"
,"SILICA - SILICA SAND"];


export const minedexSiteType = [
"Prospect"
,"Other"
,"Unknown"
,"Deposit"
,"Infrastructure"
,"Geological Observation"
,"Mine"
,"Occurrence"
,"Target"
]
